<template><div><div v-if="valid" ref="chart" class="ai-chart" role="img" :aria-label="chart.title"/><p v-else>Chart data is unavailable.</p></div></template>
<script>
import echarts from 'echarts'
export default {
  props: { chart: { type: Object, required: true } },
  computed: {
    valid() {
      const c = this.chart
      return ['line', 'bar'].includes(c.type) && typeof c.title === 'string' && Array.isArray(c.labels) && c.labels.length <= 366 &&
        c.labels.every(v => typeof v === 'string' && v.length <= 500) && Array.isArray(c.series) && c.series.length <= 5 &&
        c.series.every(s => typeof s.name === 'string' && Array.isArray(s.values) && s.values.length === c.labels.length && s.values.every(v => typeof v === 'number' && Number.isFinite(v)))
    }
  },
  mounted() {
    this.draw()
    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(() => { if (this.instance) this.instance.resize() })
      this.observer.observe(this.$el)
    }
  },
  beforeDestroy() { if (this.observer) this.observer.disconnect(); if (this.instance) this.instance.dispose() },
  watch: { chart: { deep: true, handler() { this.$nextTick(this.draw) } } },
  methods: {
    draw() {
      if (!this.valid || !this.$refs.chart) return
      if (!this.instance) this.instance = echarts.init(this.$refs.chart)
      this.instance.setOption({ title: { text: this.chart.title, textStyle: { fontSize: 12 }, left: 4 },
        tooltip: { show: false }, grid: { left: 48, right: 16, top: 48, bottom: 65 },
        xAxis: { type: 'category', data: this.chart.labels, axisLabel: { rotate: 30 } }, yAxis: { type: 'value' },
        dataZoom: this.chart.labels.length > 20 ? [{ type: 'inside' }] : [],
        series: this.chart.series.map(s => ({ name: s.name, data: s.values, type: this.chart.type, itemStyle: { color: '#ed1c24' } })) }, true)
    }
  }
}
</script>
<style scoped>.ai-chart { width: 100%; height: 270px; margin: 12px 0; }</style>
